export const BASE_URL_API_DE_NEW = process.env.REACT_APP_BASE_URL_API_DE_NEW
export const GO_DE_GQL_BACKEND_URL =
  "https://v8lkzf4yd2.execute-api.us-east-2.amazonaws.com/go-gql"

export const ENDPOINT = {
  BASE_PROXY: `${BASE_URL_API_DE_NEW}v2/proxy`,
  BASE_AUTH: `${BASE_URL_API_DE_NEW}v2/auth`,
  BASE_ENDPOINT: `${BASE_URL_API_DE_NEW}v2/collection`,
  BASE_ENDPOINT_ACADEMY: `${BASE_URL_API_DE_NEW}v2/academy`,
  BASE_ENDPOINT_TELEGRAM: `${BASE_URL_API_DE_NEW}v2/telegram`,
  CREATE_DRAFT_COLLECTION: `${BASE_URL_API_DE_NEW}v2/draft`,
  CREATE_DRAFT_COLLECTION_ORDINAL: `${BASE_URL_API_DE_NEW}v2/draft/ordinals`,
  UPDATE_DRAFT_COLLECTION: `${BASE_URL_API_DE_NEW}v2/draft`,
  UPDATE_LIVE_COLLECTION: `${BASE_URL_API_DE_NEW}v2/collection`,
  SUBMIT: `${BASE_URL_API_DE_NEW}v2/draft`,
  GET_DRAFTS: `${BASE_URL_API_DE_NEW}v2/draft`,
  DELETE_LIVE_COLLECTION: `${BASE_URL_API_DE_NEW}v2/collection`,

  GET_ROLE: `${BASE_URL_API_DE_NEW}v2/user/get_role`,
  CREATE_COLLECTION: `${BASE_URL_API_DE_NEW}v2/collection/create_collection`,
  SUBMIT_COLLECTION: `${BASE_URL_API_DE_NEW}v2/collection/submit_collection`,
  UPDATE_COLLECTION: `${BASE_URL_API_DE_NEW}v2/collection/update_collection`,
  RESPOND_TO_COLLECTION: `${BASE_URL_API_DE_NEW}v2/collection`,
  TELEGRAM_GET_STATS: `http://k8s-default-telegram-abf92ffa44-680559850.us-east-2.elb.amazonaws.com/get-stats`,
  WL_QUALIFICATION: `${BASE_URL_API_DE_NEW}v2/user/get_all_wl_qualification_data`,
  KYZZEN_USERNAMES: `${BASE_URL_API_DE_NEW}v2/user/get-all-usernames`,
  KYZZEN_USERS: `${BASE_URL_API_DE_NEW}v2/user/get-users`,
  DELETE_KYZZEN_USER: `${BASE_URL_API_DE_NEW}v2/user/delete-user`,
  LINK_TELEGRAM_MANUALLY: `${BASE_URL_API_DE_NEW}v2/user/manual-link-tg`,
  ACTIVATE_TWITTER_BOT: `${BASE_URL_API_DE_NEW}v2/proxy/twitter-bot/bot`,
  CHECK_TWITTER_BOT_STATUS: `${BASE_URL_API_DE_NEW}v2/proxy/twitter-bot/check-status`,
  GET_TWITTER_AUTH_URL: `${BASE_URL_API_DE_NEW}v2/proxy/twitter-bot/get-auth-url`,
  TWITTER_BOT_CALLBACK: `${BASE_URL_API_DE_NEW}v2/proxy/twitter-bot/callback`,
  CHECK_NEWSLETTER_BOT_STATUS: `${BASE_URL_API_DE_NEW}v2/proxy/newsletter-bot/check-status`,
  DRAFT_NEWSLETTER_POST: `${BASE_URL_API_DE_NEW}v2/proxy/newsletter-bot/make-post`,
  ACTIVATE_NEWSLETTER_BOT: `${BASE_URL_API_DE_NEW}v2/proxy/newsletter-bot/activate`,
}
